module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('el-menu', {
    attrs: {
      "theme": "dark",
      "mode": "horizontal",
      "default-active": _vm.language,
      "router": true
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/zouyaoji/vue-cesium",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/vue-cesium-logo.svg")
    }
  })])]), _c('el-menu-item', {
    staticClass: "right",
    attrs: {
      "index": "zh-CN"
    }
  }, [_vm._v("中文")]), _c('el-menu-item', {
    staticClass: "right",
    attrs: {
      "index": "en-US"
    }
  }, [_vm._v("English")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_pug@2.0.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/template-compiler?{"id":"data-v-633aceed"}!./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_pug@2.0.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_pug@2.0.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 208
// module chunks = 1